<script lang="ts" setup>
import InputWrapper, { InputWrapperProps } from '@/atoms/InputWrapper.vue';
import BaseInput, { BaseInputProps, InputState } from '@/atoms/BaseInput.vue';
import { ref } from 'vue';
import { onIonViewDidEnter } from '@ionic/vue';

export type TextAreaProps = InputWrapperProps &
  Omit<BaseInputProps, 'type'> & {
    rows?: number;
  };

const props = defineProps<TextAreaProps>();
const state = ref<InputState>(props.state ?? 'default');
const value = defineModel<string>();

const setFocused = () => {
  if (state.value !== 'disabled') {
    state.value = 'focused';
  }
};

const setDefault = () => {
  if (state.value !== 'disabled') {
    state.value = 'default';
  }
};

onIonViewDidEnter(() => {
  value.value = props.initialValue;
});
</script>

<template>
  <InputWrapper
    :id="id"
    :class="props.class"
    :destructive="destructive"
    :error="error"
    :hint="hint"
    :label="label"
    :state="state"
  >
    <BaseInput
      :id="id"
      :destructive="destructive"
      :field-props="fieldProps"
      :state="state"
      placeholder="placeholder"
      type="textarea"
    >
      <textarea
        :id="id"
        v-model="value"
        :disabled="state === 'disabled'"
        :maxlength="maxLength"
        :minlength="minLength"
        :placeholder="placeholder"
        :rows="rows"
        class="w-full h-40 font-inter text-current resize-none"
        v-bind="fieldProps"
        @blur="setDefault"
        @click="setFocused"
        @focusin="setFocused"
      />
    </BaseInput>
  </InputWrapper>
</template>
